import { useState } from "react";
import { act } from "react-dom/cjs/react-dom-test-utils.production.min";
import { CSSTransition, Transition, TransitionGroup } from "react-transition-group";
import { GalleryCreacyle } from "./GalleryCreacyle";

const ColasTypeInfosItem = ({ infos, filters }) => {
  const [isOpen, setIsOpen] = useState(true);

  // console.log(infos);
  const handleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  //--- Get activity type slug
  let activitySlug = "";
  for (const activity of filters[Object.keys(filters)[0]].values) {
    if (activity.name === infos.name) {
      activitySlug = activity.slug;
    }
  }

  //--- Format Email
  let displayEmail = [];
  if (infos.email && Object.entries(infos.email).length > 0) {
    const formatedEmail = Object.entries(infos.email);
    displayEmail = formatedEmail.map((elt, index) => {
      const [person, email] = elt;
      return (
        <div className={`email ${activitySlug}-icon`} key={elt[1] + index}>
          <div key={email + index}>
            <div className="text-bold">{person} : </div>
            <div>{email}</div>
          </div>
        </div>
      );
    });
  }

  //--- Format phone
  let displayPhone = [];
  if (infos.phone && Object.entries(infos.phone).length > 0) {
    const formatedPhone = Object.entries(infos.phone);
    displayPhone = formatedPhone.map((elt, index) => {
      const [person, phone] = elt;
      return (
        <div className={`phone ${activitySlug}-icon`} key={elt[1] + index}>
          <div className="d-flex" key={phone + index}>
            <div className="text-bold">{person} : </div>
            <div>&nbsp;{phone}</div>
          </div>
        </div>
      );
    });
  }

  //--- Format Schedule
  let displaySchedule = [];
  if (infos.schedule && Object.entries(infos.schedule).length > 0) {
    const formatedSchedule = Object.entries(infos.schedule);
    displaySchedule = formatedSchedule.map((elt, index) => {
      const [day, hours] = elt;
      return (
        <div className={`schedule ${activitySlug}-icon`} key={elt[1] + index}>
          <div key={day + index}>
            <div className="text-bold">{day} : </div>
            <div>{hours}</div>
          </div>
        </div>
      );
    });
  }

  //--- Get the color

  let color = "";
  for (const filter of filters[Object.keys(filters)[0]].values) {
    if (filter.name === infos.name) {
      color = filter.color;
    }
  }






  return (
    <>
      <p>{infos.description}</p>

    </>
  );

};

export default ColasTypeInfosItem;
